module.exports = __webpack_public_path__ + "img/bg-cart.98940e52.jpg";